import React, { lazy, Suspense } from "react";
import App from "./../app.jsx";
import { Navigate } from "react-router-dom";

import Weekly from "../pages/analytics/weekly.js";

import PagesError from "./../pages/pages/error.js";
import PagesLogin from "./../pages/pages/login.js";
import ROIPublic from "./../pages/pages/roi-public.js";
import PublicRegister from "../pages/pages/public-register";
import EmailActivate from "../pages/pages/email-activate";
import PageReset from "./../pages/pages/reset.js";
import AlarmList from "../pages/alarms/list";
import MachineComparison from "../pages/machine-comparison";
// import AlarmOverview from "../pages/alarms/overview";
import AlarmDetail from "../pages/alarms/detail";
import MachineProfile from "../pages/machine/profile";
import MachineList from "../pages/machine/list";
import MachineHierarchy from "../pages/machine/hierarchy";
import MachineAdd from "../pages/machine/add";
import SensorList from "../pages/sensor/list";
import SensorLive from "../pages/sensor/live";
import MachineHealth from "../pages/analytics/machine_health";
import PrivateRoute from "../lib/PrivateRoute.jsx";
import CompanyConfiguration from "../pages/configurations/company";
import LocationConfiguration from "../pages/configurations/location";
import RolesConfiguration from "../pages/configurations/roles";
import UserConfiguration from "../pages/configurations/users";
import TeamConfiguration from "../pages/configurations/team";
import ReportDocument from "../pages/report-document";
import Documents from "../pages/pages/documentation";
import Feedback from "../pages/configurations/feedback";
import NotificationLogs from "../pages/notification_logs";
import DocumentVideo from "../pages/pages/documentation-video";
import PagesLoginByPass from "../pages/pages/login-bypass";
import MatarAssetCondition from "../pages/matar-page/asset-condition/list";
import MatarAssetReplacement from "../pages/matar-page/asset-replacement/index";
import MatarRUList from "../pages/matar-page/asset-rul/index";
import MatarReplacementDetail from "../pages/matar-page/asset-replacement/detail";
import MatarRULDetail from "../pages/matar-page/asset-rul/detail";
import MatarWorkOrder from "../pages/matar-page/asset-work-order/index";
import MatarWorkOrderDetail from "../pages/matar-page/asset-work-order/asset-detail";
import MatarWorkOrderGroupDetail from "../pages/matar-page/asset-work-order/group_detail";
import MatarAssetList from "../pages/matar-page/matar-asset-list/index";
import MatarDashboard from "../pages/matar-dashboard/dashboard";
import MatarInvestmentProfileList from "../pages/matar-page/investment-profile/index";
import MatarInvestmentProfileDetail from "../pages/matar-page/investment-profile/detail";
import MatarLifecycle from "../pages/matar-page/matar-asset-list/lifecycle";
import MatarGroupConfig from "../pages/configurations/matar-group";
import PublicRequest from "../pages/request/add";
import PublicRequestTracker from "../pages/request/tracking";
import MatarFinancialStrategy from "../pages/matar-page/financial-strategies";
import MatarFinancialDetail from "../pages/matar-page/financial-strategies/detail";
import DocumentsAiList from "../pages/ai-pdf/list";
import DocumentChat from "../pages/ai-pdf/chat";
import NotificationHierarchyConfiguration from "../pages/configurations/notification-hierarchy/index.jsx";
import { ChatAssistantIFrame } from "../pages/ai/ChatAssistantIFrame.jsx";
import MachineMonitoring from "../pages/machine-monitoring";
import OverviewPage from "../pages/dashboard/index";
import Dashboard from "../pages/dashboard/dashboard.js";
import FaqList from "../pages/faq/faq";
const AlarmOverview = lazy(() => import("../pages/alarms/overview"));
const ReportPage = lazy(() => import("../pages/report"));

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Navigate to="/dashboard" />
          </PrivateRoute>
        ),
      },
      {
        path: "dashboard",
        element: (
          <PrivateRoute>
            <OverviewPage />
          </PrivateRoute>
        ),
      },
      {
        path: "overview",
        element: (
          <PrivateRoute>
            <OverviewPage />
          </PrivateRoute>
        ),
      },
      {
        path: "matar-dashboard",
        element: (
          <PrivateRoute>
            <MatarDashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "notification-logs",
        element: (
          <PrivateRoute>
            <NotificationLogs />
          </PrivateRoute>
        ),
      },
      {
        path: "machine-health",
        element: (
          <PrivateRoute>
            <MachineHealth />
          </PrivateRoute>
        ),
      },
      {
        path: "machine-monitoring",
        element: (
          <PrivateRoute>
            <MachineMonitoring />
          </PrivateRoute>
        ),
      },
      {
        path: "machine-comparison",
        element: (
          <PrivateRoute>
            <MachineComparison />
          </PrivateRoute>
        ),
      },
      { path: "login", element: <PagesLogin /> },
      { path: "chat-assistant", element: <ChatAssistantIFrame /> },
      { path: "login-by-pass/*", element: <PagesLoginByPass /> },
      { path: "public-register", element: <PublicRegister /> },
      { path: "public-request/:token", element: <PublicRequest /> },
      { path: "tracking-request/:id", element: <PublicRequestTracker /> },
      { path: "roi-calculator", element: <ROIPublic /> },
      { path: "password/*", element: <PageReset /> },
      { path: "account/*", element: <EmailActivate /> },
      {
        path: "analytics",
        element: (
          <PrivateRoute>
            <Weekly />{" "}
          </PrivateRoute>
        ),
      },

      {
        path: "machine/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                {" "}
                <MachineList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "hierarchy",
            element: (
              <PrivateRoute>
                {" "}
                <MachineHierarchy />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:machineId",
            element: (
              <PrivateRoute>
                {" "}
                <MachineAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                {" "}
                <MachineAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: ":machineId",
            element: (
              <PrivateRoute>
                {" "}
                <MachineProfile />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "machine-asset/*",
        children: [
          {
            path: "condition",
            element: (
              <PrivateRoute>
                {" "}
                <MatarAssetCondition />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "asset-list",
            element: (
              <PrivateRoute>
                {" "}
                <MatarAssetList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "financial-strategies",
            element: (
              <PrivateRoute>
                {" "}
                <MatarFinancialStrategy />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "financial-detail",
            element: (
              <PrivateRoute>
                {" "}
                <MatarFinancialDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "investment-list",
            element: (
              <PrivateRoute>
                {" "}
                <MatarInvestmentProfileList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "replacement",
            element: (
              <PrivateRoute>
                {" "}
                <MatarAssetReplacement />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "rul",
            element: (
              <PrivateRoute>
                {" "}
                <MatarRUList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "rul-detail/:assetId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarRULDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "rul-group/:groupId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarRULDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "lifecycle/:assetId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarLifecycle />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "lifecycle-group/:groupId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarLifecycle />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "investment-detail/:assetId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarInvestmentProfileDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "investment-group/:groupId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarInvestmentProfileDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "asset-replacement-detail/:assetId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarReplacementDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "asset-detail/:id",
            element: (
              <PrivateRoute>
                {" "}
                <MatarWorkOrderDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "asset-group-detail/:groupId/:locationId",
            element: (
              <PrivateRoute>
                {" "}
                <MatarWorkOrderGroupDetail />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "work-order",
            element: (
              <PrivateRoute>
                {" "}
                <MatarWorkOrder />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "sensor/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                {" "}
                <SensorList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "live/:machineId",
            element: (
              <PrivateRoute>
                {" "}
                <SensorLive />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "report/*",
        children: [
          {
            path: "export",
            element: (
              <PrivateRoute>
                <Suspense fallback={<div>Loading...</div>}>
                  <ReportPage />{" "}
                </Suspense>
              </PrivateRoute>
            ),
          },
          {
            path: "document",
            element: (
              <PrivateRoute>
                {" "}
                <ReportDocument />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "document/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                {" "}
                <DocumentsAiList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "doc-chat",
            element: (
              <PrivateRoute>
                {" "}
                <DocumentChat />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "video",
            element: (
              <PrivateRoute>
                {" "}
                <Documents />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "configuration/*",
        children: [
          {
            path: "company",
            element: (
              <PrivateRoute>
                <CompanyConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "feedback",
            element: (
              <PrivateRoute>
                <Feedback />
              </PrivateRoute>
            ),
          },
          {
            path: "group",
            element: (
              <PrivateRoute>
                <MatarGroupConfig />
              </PrivateRoute>
            ),
          },
          {
            path: "location",
            element: (
              <PrivateRoute>
                <LocationConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "roles",
            element: (
              <PrivateRoute>
                <RolesConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "users",
            element: (
              <PrivateRoute>
                <UserConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "teams",
            element: (
              <PrivateRoute>
                <TeamConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "notification-hierarchy",
            element: (
              <PrivateRoute>
                <NotificationHierarchyConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "faq",
            element: (
              <PrivateRoute>
                <FaqList />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "alarm/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                {" "}
                <AlarmList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "overview",
            element: (
              <PrivateRoute>
                {" "}
                <Suspense fallback={<div>Loading...</div>}>
                  <AlarmOverview />{" "}
                </Suspense>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:alarmId",
            element: (
              <PrivateRoute>
                {" "}
                <AlarmDetail />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      { path: "*", element: <PagesError /> },
    ],
  },
];

export default AppRoute;
